import { HomeDialogEventName } from "event-tracker/dialog-event-name";
import {
  HENRIQUE_E_JULIANO,
  KAMILLA_FIALHO,
  ANNO_DOMINI,
} from "shared/constants/SpecialCampaignConst";
import { ClientSpecialCampaignApprovalEnum } from "shared/enums/ClientSpecialCampaignApprovalEnum";
import { MotivoNaoElegivelEnum } from "shared/enums/MotivoNaoElegivelEnum";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";

const SPECIAL_CAMPAIGN_KEY = "specialCampaign";

const campaignConstByEnum = (campaign: string) => {
  switch (campaign) {
    case SpecialCampaignEnum.HenriqueEJuliano:
      return HENRIQUE_E_JULIANO;
    case SpecialCampaignEnum.KamillaFialho:
      return KAMILLA_FIALHO;
    case SpecialCampaignEnum.AnnoDomini:
      return ANNO_DOMINI;
  }
  return null;
};

export const saveSessionSpecialCampaign = (specialCampaign: string | null) => {
  if (!specialCampaign || specialCampaign === null) return;
  const campaign = campaignConstByEnum(specialCampaign);
  if (campaign) {
    sessionStorage.setItem(SPECIAL_CAMPAIGN_KEY, campaign);
  }
};

export const getSessionSpecialCampaign = () =>
  sessionStorage.getItem(SPECIAL_CAMPAIGN_KEY);

export const artistOriginSpecialCampaign = (specialCampaign: string) => {
  const campaign = campaignConstByEnum(specialCampaign);
  if (!campaign) return false;
  const sessionCampaign = sessionStorage.getItem(SPECIAL_CAMPAIGN_KEY);
  return campaign === sessionCampaign;
};

export const removeSessionSpecialCampaign = (specialCampaign: string) => {
  const campaign = campaignConstByEnum(specialCampaign);
  if (!campaign) return false;
  sessionStorage.removeItem(SPECIAL_CAMPAIGN_KEY);

  return true;
};

export const findSpecialCampaign = (listCampaign: any[], campaign: string) => {
  return listCampaign?.some((item: any) => item.name === campaign) ?? false;
};

export const getSpecialCampaign = (listCampaign: any[], campaign: string) => {
  return listCampaign?.find((item: any) => item.name === campaign) ?? null;
};

export const getDialogEventNameByIneligibleReason = (
  reason: MotivoNaoElegivelEnum
): HomeDialogEventName => {
  switch (reason) {
    case MotivoNaoElegivelEnum.Estagio:
      return HomeDialogEventName.SPECIAL_CAMPAIGN_INELEGIBLE_STAGE_CAREER;
    case MotivoNaoElegivelEnum.AdiantamentoEmProgresso:
      return HomeDialogEventName.SPECIAL_CAMPAIGN_INELEGIBLE_CURRENT_ADVANCE;
    case MotivoNaoElegivelEnum.Genero:
      return HomeDialogEventName.SPECIAL_CAMPAIGN_INELEGIBLE_GENRE;
    case MotivoNaoElegivelEnum.Pais:
      return HomeDialogEventName.SPECIAL_CAMPAIGN_INELEGIBLE_COUNTRY;
    case MotivoNaoElegivelEnum.DistroEmProgresso:
      return HomeDialogEventName.SPECIAL_CAMPAIGN_INELEGIBLE_CURRENT_DISTRO;
  }
};

export const getDialogEventNameByApproval = (
  approval: ClientSpecialCampaignApprovalEnum
): HomeDialogEventName => {
  if (approval === ClientSpecialCampaignApprovalEnum.Approved)
    return HomeDialogEventName.SPECIAL_CAMPAIGN_SELECTED;

  return HomeDialogEventName.SPECIAL_CAMPAIGN_NOT_SELECTED;
};

const getNotEligibleDateKey = (specialCampaign: string) => {
  const campaign = campaignConstByEnum(specialCampaign);
  return campaign ? `notEligibleSpecialCampaignDate_${campaign}` : null;
};

export const saveNotEligibleDate = (specialCampaign: string) => {
  const key = getNotEligibleDateKey(specialCampaign);
  if (!key) return;
  localStorage.setItem(key, new Date().toISOString());
};

export const getNotEligibleDate = (specialCampaign: string): Date | null => {
  const key = getNotEligibleDateKey(specialCampaign);
  if (!key) return null;
  const dateString = localStorage.getItem(key);
  return dateString ? new Date(dateString) : null;
};

export const hasPassedDaysSinceNotEligible = (
  specialCampaign: string,
  days: number
): boolean => {
  const notEligibleDate = getNotEligibleDate(specialCampaign);
  if (!notEligibleDate) return false;
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const elapsedDays = Math.floor(
    (new Date().getTime() - notEligibleDate.getTime()) / millisecondsPerDay
  );
  return elapsedDays >= days;
};

export const isWithinDaysSinceNotEligible = (
  specialCampaign: string,
  days: number
): boolean => {
  const notEligibleDate = getNotEligibleDate(specialCampaign);
  if (!notEligibleDate) return false;
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const elapsedDays = Math.floor(
    (new Date().getTime() - notEligibleDate.getTime()) / millisecondsPerDay
  );

  return elapsedDays < days;
};
